module.exports = __webpack_public_path__ + "Gotham-Light.eb8f73acf780eb520983.woff2";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Light.woff2
// module id = ../../../../../src/assets/fonts/Gotham-Light.woff2
// module chunks = 2